const action = (key, label) => ({ key, label });

export const PERMISSION_SECTIONS = [
  {
    id: "overview",
    items: [
      { featureFlag: "enableDashboard", label: "Dashboard", actionGroups: [] },
    ],
  },
  {
    id: "commerce",
    items: [
      {
        featureFlag: "enableGestioneEcommerce",
        label: "Gestione E-Commerce",
        actionGroups: [
          {
            id: "gestioneEcommerce",
            actions: [
              action("attiva", "Attiva vendor"),
              action("storicoAzioni", "Apri storico azioni"),
              action("modifica", "Modifica anagrafica"),
              action("impersona", "Impersona vendor"),
              action("rifiuta", "Rifiuta attivazione"),
              action("sospendi", "Sospendi account"),
              action("riattiva", "Riattiva account"),
              action("altreAzioni", "Altre azioni account"),
              action("credito", "Gestione credito"),
            ],
          },
          {
            id: "storicoAzioni",
            label: "- - -",
            actions: [
              action("dettagli", "Dettaglio Azioni"),
              action("rollback", "Rollback azione"),
            ],
          },
        ],
      },
      {
        featureFlag: "enableGestioneProdotti",
        label: "Gestione Prodotti",
        actionGroups: [{
          id: "gestioneProdotti",
          actions: [
            action("statistiche", "Statistiche prodotto"),
            action("cambiaStato", "Cambia stato prodotto"),
          ],
        }],
      },
      {
        featureFlag: "enableGestioneCategorie",
        label: "Gestione Categorie",
        actionGroups: [{
          id: "gestioneCategorie",
          actions: [
            action("modifica", "Modifica categoria"),
            action("elimina", "Elimina categoria"),
          ],
        }],
      },
      {
        featureFlag: "enableManutenzioneCataloghi",
        label: "Manutenzione Cataloghi",
        actionGroups: [{
          id: "manutenzioneCataloghi",
          actions: [
            action("serviceConfig", "Configurazione servizio"),
            action("vendorSchedule", "Schedule vendor"),
            action("mapping", "Mapping catalogo"),
            action("import", "Import catalogo"),
            action("catalogo", "Operazioni catalogo"),
            action("productCodeRegen", "Rigenera codici prodotto"),
            action("bulkCategorize", "Categorizzazione massiva"),
          ],
        }],
      },
    ],
  },
  {
    id: "usersSupport",
    items: [
      {
        featureFlag: "enableGestioneUtenti",
        label: "Gestione Utenti",
        actionGroups: [{
          id: "gestioneUtenti",
          actions: [
            action("riattiva", "Riattiva utente"),
            action("elimina", "Elimina utente"),
          ],
        }],
      },
      {
        featureFlag: "enableGestioneTickets",
        label: "Gestione Tickets",
        actionGroups: [{
          id: "gestioneTickets",
          actions: [
            action("autoAssegnazione", "Auto-assegnazione"),
            action("assegnaAdAltri", "Assegna ad altri admin"),
          ],
        }],
      },
    ],
  },
  {
    id: "content",
    items: [
      {
        featureFlag: "enableNewsletter",
        label: "Newsletter",
        actionGroups: [{
          id: "newsletterStorico",
          actions: [
            action("annullaProgrammato", "Annulla invio programmato"),
            action("dettagli", "Dettaglio storico invii"),
          ],
        }],
      },
      {
        featureFlag: "enableGestioneContenuti",
        label: "Gestione Contenuti",
        actionGroups: [],
        menuParentOnly: true,
      },
      {
        featureFlag: "enableGestioneBanners",
        label: "Banners",
        actionGroups: [{ id: "gestioneBanner", actions: [action("elimina", "Elimina banner")] }],
        nestedUnder: "enableGestioneContenuti",
      },
      {
        featureFlag: "enableMagazine",
        label: "Magazine",
        actionGroups: [{
          id: "gestioneMagazine",
          actions: [
            action("modificaArticolo", "Modifica articolo"),
            action("eliminaArticolo", "Elimina articolo"),
            action("eliminaCategoria", "Elimina categoria magazine"),
            action("nascondiArticolo", "Nascondi articolo"),
          ],
        }],
        nestedUnder: "enableGestioneContenuti",
      },
    ],
  },
  {
    id: "sync",
    items: [
      {
        featureFlag: "enableSincronizzazione",
        label: "Sincronizzazione",
        actionGroups: [],
      },
      {
        featureFlag: "enableSincronizzazioneIndicizzazione",
        label: "Reindex prodotti",
        actionGroups: [],
        nestedUnder: "enableSincronizzazione",
      },
      {
        featureFlag: "enableSincronizzazioneCacheCategorie",
        label: "Cache categorie",
        actionGroups: [],
        nestedUnder: "enableSincronizzazione",
      },
      {
        featureFlag: "enableSincronizzazioneProdottiScelti",
        label: "Cache prodotti selezionati",
        actionGroups: [],
        nestedUnder: "enableSincronizzazione",
      },
      {
        featureFlag: "enableSincronizzazioneStripe",
        label: "Sync clienti Stripe",
        actionGroups: [],
        nestedUnder: "enableSincronizzazione",
      },
    ],
  },
  {
    id: "settings",
    items: [
      {
        featureFlag: "enableImpostazioni",
        label: "Impostazioni",
        actionGroups: [],
        menuParentOnly: true,
      },
      {
        featureFlag: "enableGestioneParametri",
        label: "Parametri generali",
        actionGroups: [],
        nestedUnder: "enableImpostazioni",
      },
      {
        featureFlag: "enableConfigurazioneStripe",
        label: "Configurazione Stripe",
        actionGroups: [],
        nestedUnder: "enableImpostazioni",
      },
      {
        featureFlag: "enableMetodiPagamento",
        label: "Metodi di pagamento",
        actionGroups: [],
        nestedUnder: "enableImpostazioni",
      },
      {
        featureFlag: "enableGestionePermessi",
        label: "Gestione permessi",
        actionGroups: [],
        nestedUnder: "enableImpostazioni",
      },
    ],
  },
];

/** Flat list of editable permission rows for the settings UI. */
export function getPermissionEditorRows() {
  const rows = [];
  PERMISSION_SECTIONS.forEach((section) => {
    section.items.forEach((item) => {
      rows.push({ sectionId: section.id, ...item });
    });
  });
  return rows;
}

const DEPLOYMENT_OVERRIDES = {
  enableGestioneParametri: false,
  enableConfigurazioneStripe: false,
  enableSincronizzazioneStripe: false,
  gestioneEcommerce: { credito: false },
};

export function buildMasterFeatureFlags() {
  const flags = {};
  PERMISSION_SECTIONS.forEach((section) => {
    section.items.forEach((item) => {
      if (!(item.featureFlag in flags)) {
        flags[item.featureFlag] = DEPLOYMENT_OVERRIDES[item.featureFlag] !== false;
      }
    });
  });
  return flags;
}

export function buildMasterActionFlags() {
  const groups = {};
  PERMISSION_SECTIONS.forEach((section) => {
    section.items.forEach((item) => {
      item.actionGroups?.forEach((group) => {
        if (!groups[group.id]) {
          groups[group.id] = {};
        }
        group.actions.forEach(({ key }) => {
          const override = DEPLOYMENT_OVERRIDES[group.id]?.[key];
          groups[group.id][key] = override !== false;
        });
      });
    });
  });
  return groups;
}

export function getActionGroupKeys() {
  return buildMasterActionFlags() && Object.keys(buildMasterActionFlags());
}

export function getFeatureFlagLabel(featureFlag) {
  for (const section of PERMISSION_SECTIONS) {
    const item = section.items.find((i) => i.featureFlag === featureFlag);
    if (item) {
      return item.label;
    }
  }
  return featureFlag;
}

export function getActionLabel(actionGroup, actionKey) {
  for (const section of PERMISSION_SECTIONS) {
    for (const item of section.items) {
      for (const group of item.actionGroups ?? []) {
        if (group.id !== actionGroup) {
          continue;
        }
        const actionDef = group.actions.find((a) => a.key === actionKey);
        if (actionDef) {
          return actionDef.label;
        }
      }
    }
  }
  return actionKey;
}
